import { render } from "./Receival.vue?vue&type=template&id=157b1634"
import script from "./Receival.vue?vue&type=script&lang=js"
export * from "./Receival.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__